import React from 'react';
import './ContainerMatch.css';
import PlayoffsMatch from './PlayoffsMatch';

const ContainerMatch = ({
    championnat,
    clubTop,
    clubBot,
    getEncounter,
    getWinner,
    lineHeight = 20,
    lineWidth = 200,
    isFinal = false,
    invertedLine = false,
    style,
    returnMatch = true,
    displayMessage = "",
}) => {

    return ( 
        <div className='container_match_component' style={style}>

            {/* RENCONTRE */}
            <div className='container_match_encounter'>
                {/* 1ERE TEAM */}
                <div style={{paddingLeft: invertedLine ? 20 : 0}}>
                    <PlayoffsMatch club={clubTop} matchs={getEncounter(clubTop, clubBot)} championnat={championnat} returnMatch={returnMatch} />
                </div>
                {/* JOINTURES */}
                <div
                    className={`container_match_separator`}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: lineWidth,
                        height: lineHeight,
                        marginLeft: !invertedLine ? 180 : 0,
                        borderLeft: !invertedLine ? '4px solid black' : 0,
                        borderRight: invertedLine ? '4px solid black' : 0
                    }}
                />
                {displayMessage && (
                    <div style={{position: "absolute", marginTop: "-40px", marginLeft: "200px", backgroundColor: "white", padding: "4px 20px 4px 20px", borderRadius: "10px 10px 0px 0px"}}>
                        {displayMessage}
                    </div>
                )}
                
                {/* 2EME TEAM */}
                <div style={{paddingLeft: invertedLine ? 20 : 0}}>
                    <PlayoffsMatch club={clubBot} matchs={getEncounter(clubTop, clubBot)} championnat={championnat} returnMatch={returnMatch} />
                </div>
            </div>

            {isFinal && (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div 
                        style={{
                            borderTop: '4px solid var(--yellow-color)',
                            borderBottom: '4px solid var(--yellow-color)',
                            borderRight: '4px solid var(--yellow-color)',
                            width: 64,
                            height: 95,
                        }}
                    />
                    <div 
                        style={{
                            width: 20,
                            height: 4,
                            backgroundColor: 'var(--yellow-color)'
                        }}
                    />
                </div>
            )}
            {
                isFinal && (
                     <PlayoffsMatch clubWinner={getWinner(clubTop?.ranking, clubBot?.ranking)} onlyWinner />
                )
            }
        </div>
    );
}
 
export default ContainerMatch;